"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataValue = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var DataValue = function (_a) {
    var children = _a.children, placeholder = _a.placeholder, _b = _a.style, style = _b === void 0 ? {} : _b;
    return (React.createElement(DataValueWrapper, { style: style }, children || (placeholder ? '--' : '')));
};
exports.DataValue = DataValue;
var DataValueWrapper = styled_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 1.1667rem;\n  font-weight: bold;\n  margin-bottom: 1.33rem;\n"], ["\n  font-size: 1.1667rem;\n  font-weight: bold;\n  margin-bottom: 1.33rem;\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map